<template>
  <ScrollArea class="filters" :fade="fade">
    <Chips>
      <Chip
        v-for="filter of filters"
        :key="filter?.toString()"
        :is-active="filter === selectedFilter"
        @click="selectFilter(filter)"
      >
        <span class="label">
          {{ filter }}
          <CountBadge v-if="countOf(filter) > 0" :count="countOf(filter)" :max="99" />
        </span>
      </Chip>
    </Chips>
  </ScrollArea>
</template>

<script setup lang="ts" generic="T">
import Chip from './chips/chip.vue';
import Chips from './chips/chips.vue';
import CountBadge from './count-badge.vue';
import ScrollArea from './scroll-area.vue';

const props = withDefaults(
  defineProps<{
    filters: T[];
    selectedFilter: T;
    /** The row never wraps; the fade shows the edge that still hides chips */
    fade?: boolean;
    /** A badge after the label, for the filters listed here with more than zero */
    counts?: Map<T, number>;
  }>(),
  { fade: true },
);

const emit = defineEmits<{ selected: [filter: T] }>();

function selectFilter(filter: T) {
  emit('selected', filter);
}

function countOf(filter: T) {
  return props.counts?.get(filter) ?? 0;
}
</script>

<style scoped lang="scss">
.filters {
  flex-shrink: 0;
}

// A flex row drops the space before the badge, so the gap alone sets the distance
.label {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
}
</style>
